import { gsap, ScrollTrigger, DrawSVGPlugin } from 'gsap/all'
import { splitText } from './split-text'
import { splitTitle } from './split-title'
import { divider } from './divider'
import { imageMask } from './image-mask'
import { fadeInUp } from './fade-in-up'

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

export function imageSideTextSide(element: HTMLElement) {
  const keyline = element.querySelector('.js-keyline svg polygon') as SVGPathElement
  const title = element.querySelector('.js-title') as HTMLElement // split title
  const sectionDivider = element.querySelector('.js-divider') as HTMLElement // divider
  const subtitle = element.querySelector('.js-subtitle') as HTMLElement // split text
  const quote = element.querySelector('.js-quote') as HTMLElement //split text
  const sectionImageMask = element.querySelector('.js-image-mask') as HTMLElement // imagemask
  const button = element.querySelector('.js-button') as HTMLElement // fadeinup
  let mm = gsap.matchMedia()

  mm.add('(min-width: 768px)', () => {
    if (keyline) {
      gsap.set(keyline, { drawSVG: '0%', autoAlpha: 0 })
      gsap.to(keyline, { drawSVG: '100%', duration: 1.8, ease: 'expo.out', delay: 0.35, autoAlpha: 1 })
    }

    if (title) splitTitle(title, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false })
    if (sectionDivider)
      divider(sectionDivider, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false })
    if (subtitle)
      splitText(subtitle, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false })
    if (quote) splitText(quote, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false })
    if (sectionImageMask)
      imageMask(sectionImageMask, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false })
    if (button) fadeInUp(button, { trigger: element, start: 'top+=25% bottom', end: 'center bottom', markers: false })

    // need a scrolltrigger that runs the functions
  })
}
